import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useNotificationEvents() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.NOTIFICATION_EVENTS}/list`,
    { method: 'GET', cacheResponse: true }
  );
}
